<template>
  <MaintenanceBanner />
  <router-view />
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import { useMeta } from 'quasar';
import { useGlobalStore } from 'src/stores/useGlobalStore';
import { useUserStore } from 'src/stores/useUserStore';
import { axiosApi } from 'src/utils/axios';
import dayjs from 'dayjs';
import { useUpdateStore } from 'src/stores/useUpdateStore';
import MaintenanceBanner from 'src/components/MaintenanceBanner.vue';
import { usePresenceHeartbeat } from 'src/composables/usePresenceHeartbeat';

const UserStore = useUserStore();
const GlobalStore = useGlobalStore();
const UpdateStore = useUpdateStore();

// Installed at the root, not in a layout: the punch screens and the admin shell
// are different layouts, and a heartbeat that stops when somebody navigates
// between them is how presence lies.
usePresenceHeartbeat();

onMounted(() => {
  useMeta({ title: process.env.APP_NAME });
  GlobalStore.updateVirtualDate();
  if (UserStore.token) {
    axiosApi.defaults.headers.common['Authorization'] = `Bearer ${UserStore.token}`;
  }
  if (UserStore.details.id) {
    UserStore.initUser();
  }

  // Only announce the update; restarting is the user's call (see UpdateHandler).
  GlobalStore.setconnectionStatus().then(() => UpdateStore.checkForUpdates({ notification: false }));
  dayjs.updateLocale('fr-ca', {
    weekStart: GlobalStore.serverSettings.FIRST_DAY_OF_WEEK
  });
});
</script>
